<div class="bg-white rounded-4 mb-3 ps-3 pt-3 pe-3 pb-2 position-relative div-shadow" *ngIf="!loading">
  <!-- Organizador -->
  <div class="fw-bold mb-2 text-iguau">Organiza</div>
  <div class="d-flex w-100 pointer mb-2" (click)="goPerfil(paseo)">
    <div class="me-1">
      <img
        *ngIf="paseo?.foto_principal_thumb"
        [src]="paseo?.foto_principal_thumb || global.urlServer + 'img/default-user.png'"
        class="rounded-circle pointer"
        width="50px">
    </div>
    <div>
      {{paseo.first_name | firstWord}}
      <div class="text-secondary small">
        <span *ngIf="paseo.sexo=='Hombre'"><i class="fa-solid fa-mars"></i></span>
        <span *ngIf="paseo.sexo=='Mujer'"><i class="fa-solid fa-venus"></i></span>
        {{paseo.sexo}} {{paseo.edad}}
        <div>
        <span *ngIf="paseo.barrio">{{paseo.barrio}}</span>
        <span *ngIf="paseo.ciudad"><span *ngIf="paseo.barrio" class="me-1">,</span>{{paseo.ciudad}}</span>
        </div>
      </div>
    </div>
  </div>
  <!-- Mascotas del organizador -->
  <div class="w-100 pointer mb-3" (click)="goPerfil(paseo)">
    <div class="align-items-top position-relative" *ngFor="let mascota of paseo.mascotas">
      <div class="d-flex w-100 pointer" (click)="goPerfil(paseo)">
        <div class="me-1">
          <img
            *ngIf="mascota.foto_principal_thumb"
            [src]="mascota.foto_principal_thumb || global.urlServer + 'img/default-user.png'"
            class="rounded-circle pointer"
            width="50"
            [style.zIndex]="100">
        </div>
        <div>
          {{mascota.ma_nombre | firstWord}}
          <div class="text-secondary small">
            <div>
              <span *ngIf="mascota.ma_sexo=='Macho'" title="Sexo"><i class="fa-solid fa-mars"></i></span>
              <span *ngIf="mascota.ma_sexo=='Hembra'" title="Sexo"><i class="fa-solid fa-venus"></i></span>
              <span *ngIf="mascota.ma_sexo=='Hembra' || mascota.ma_sexo=='Macho'" title="Sexo" class="ms-1">{{mascota.ma_sexo}}</span>
              <span *ngIf="mascota.ma_edad" class="ms-1">{{mascota.ma_edad}}</span>
            </div>
            <span *ngIf="mascota.ma_tipo" title="Tipo">{{mascota.ma_tipo}}</span>
            <span *ngIf="mascota.ma_raza" title="Raza" class="ms-1">{{mascota.ma_raza}}</span>
            <span *ngIf="mascota.ma_tamano" title="Tamaño" class="ms-1">{{mascota.ma_tamano}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Detalles del paseo -->
  <div class="fw-bold mb-2 text-iguau">Donde</div>
  <div class="mb-3">
    <i class="fa-solid fa-location-dot"></i> {{paseo.pa_ubicacion}}
    <a class="pointer custom-link" (click)="verEnMapa()"><i class="fa-solid fa-map-location-dot"></i> Ver en el mapa</a>
  </div>

  <div class="fw-bold mb-2 text-iguau">Cuando</div>
  <div class="mb-3">
    <i class="fa-regular fa-calendar-days"></i> {{paseo.pa_fecha | cuandoFechas}} a las {{paseo.pa_hora}}
    <div class="mt-2 mb-2 w-100 align-items-center justify-content-center">
      <app-calendario [fecha]="paseo.pa_fecha"></app-calendario>
    </div>
  </div>
</div>
